const Aux = ({ children }) => children;

export default Aux;
